import 'jq/req/mobilefix';
import 'jq/req/eutils';
import 'jq/req/ga';
import 'jq/req/x/cookie';
import 'jq/req/q-cookieconsent';
import 'jq/req/onformatchange';
import 'jq/req/mobilemenu';
import 'jq/req/autovalidate';
import 'jq/req/anchortags';
import 'jq/req/selectybox';
import 'jq/req/treecollapse';
import 'jq/req/whenonscreen';
// import 'jq/req/fieldsetcloner';
// import 'jq/req/q-paginazor';
// import 'jq/req/listscroller';
import 'jq/req/delayedhighlight';
// import 'jq/req/tabswitcher';
// import 'jq/req/q-videolinks';
// import 'jq/req/x/ui-core-1.12';
// import 'jq/req/x/ui-menu-1.12';
// import 'jq/req/x/ui-autocomplete-1.12';
// import 'jq/req/x/ui-datepicker-1.12';
import 'jq/req/q-elasticsearch';
import 'jq/req/sharebtns';

import cfg from './config.json';

window.jQuery(function($) {
	'use strict';

	const $html = $('html');

	const $win = $(window);
	// var $body = $( 'body' );
	const $doc = $(document);

	const formatMonitor = $.formatChange(window.FormatChange.makeGroups(cfg.mediaFormats));
	const media = formatMonitor.media;

	const i18n = { en: {} };

	i18n.is = $.beget(i18n.en);
	const txt = i18n[$('html').attr('lang')] || i18n.en;

	// =========================================================================================================================
	//   Default Configs
	// =========================================================================================================================

	// =========================================================================================================================
	//   Actions
	// =========================================================================================================================

	// const loggedIn = window.EPLICA_loggedin;
	// const noop = $.noop;

	const scrollToElm = (window.scrollToElm = (target, duration) => {
		const targetTop = $(target).offset().top - 100;

		duration = duration || 450;
		$('html, body').animate({ scrollTop: targetTop }, duration, 'swing', function() {
			if (targetTop !== 0) {
				$html.removeClass('is-header-shown');
			} else {
				$html.addClass('is-header-unfixed');
				$html.removeClass('is-header-fixed');
			}
		});
	});

	const tagFileAndExternalLinks = () => {
		i18n.en.newWindow = 'Opens in new window';
		i18n.is.newWindow = 'Opnast í nýjum vafraglugga';
		i18n.en.fileText = 'file';
		i18n.is.fileText = 'skjal';

		$('a:not(.videolink)').anchorTags({
			usePatterns: ['doc', 'pdf', 'xls'],
			// localDomains: ['\\.*.eplica.is','\\.*.domain.is'],
			onTag: function(link, is) {
				const text = is.pattern
					? is.pattern[0].toUpperCase() + ' ' + txt.fileText
					: is.external
					? txt.newWindow
					: '';
				text &&
					link
						.attr('target', '_blank')
						.attr('title', $.trim(link.attr('title') || link.text()) + ' (' + text + ')');

				if (link.find('img').length) {
					link.addClass('has-image');
				}

				const gaCat = is.external
					? 'external'
					: is.tel
					? 'telephone'
					: is.mailto
					? 'email'
					: is.pattern
					? 'download'
					: '';
				if (window.ga && gaCat) {
					link.on('click', function(/*e*/) {
						window.gaHXM.eventPing(
							gaCat,
							is.pattern ? 'click-' + is.pattern[0] : 'click',
							link.attr('href').replace(/^(tel|mailto):/i, ''),
							1,
							is.external ? true : false
						);
					});
				}
			},
		});
	};

	const initContentlist = () => {
		const contentlistJumpers = $('.contentlist__item--jumper');
		if (contentlistJumpers.length) {
			contentlistJumpers.on('click', function(e) {
				e.preventDefault();
				const target = $($(this).attr('href'));
				if (target.length) {
					scrollToElm(target);
				}
			});
		}
	};

	const prepArticleContent = () => {
		$('.article').each(function() {
			// console.log('article');
			const article = $(this);
			_injectShareBtns(article);
		});
	};

	const _injectShareBtns = function(article) {
		$('<ul class="share-widgets" />')
			.sharebtns({
				custom: true,
				wrap: 'li',
				// countNone: true,
				fbshare: 1,
				twitter: 2,
				// gplus:     2,
				// pinterest: 3,
				facebook: false,
			})
			.end()
			.appendTo(article.find('.article__content'));
	};

	const initForms = () => {
		$html.find('select').selectybox();
		$('form').autoValidate({
			errorMsgType: 'inlineonly',
			validateEachField: 'change',
		});
	};

	const handleTelephoneLinks = () => {
		// depends on formatChange()
		i18n.is.callPrompt = 'Hringja í ';
		i18n.en.callPrompt = 'Call ';
		$doc.on('click', 'a[href^="tel:"]', function(e) {
			if (media.isLarge) {
				const m = $(this)
						.text()
						.match(/\+?\d[\s\-\d]+\d/),
					num = (m && m[0]) || this.href.substr(4);
				if (!confirm(txt.callPrompt + num + ' ?')) {
					e.preventDefault();
				}
			}
		});
	};

	const initContentblocksAnimations = () => {
		const $contentblocks = $('.contentblock');
		if ($contentblocks.length) {
			const ranges =
				media.format === 'wide'
					? { top: '-25%s', bottom: '-5%s' }
					: media.isHeaderLarge
					? { top: '-15%s', bottom: '-5%s' }
					: { top: '-5%s', bottom: '-2%s' };
			$contentblocks
				.whenOnScreen({
					live: true,
					ranges: { visible: ranges },
				})
				.on('whenonscreen', function() {
					$(this)
						.addClass('onscreen')
						.off('whenonscreen');
				});
		}

		const $contentListItems = $('.contentlist .contentlist__item');
		if ($contentListItems.length) {
			const ranges =
				media.format === 'wide'
					? { top: '-25%s', bottom: '-5%s' }
					: media.isHeaderLarge
					? { top: '-15%s', bottom: '-5%s' }
					: { top: '-5%s', bottom: '-2%s' };
			$contentListItems
				.whenOnScreen({
					live: true,
					ranges: { visible: ranges },
				})
				.on('whenonscreen', function() {
					$(this)
						.addClass('visible')
						.off('whenonscreen');
				});
		}
	};

	const initMegaNav = () => {
		const menubar = $('.pgnav');
		const $meganav = menubar.find('.meganav .mnav__ul');

		menubar.on('click', function(e) {
			e.stopPropagation();
		});

		menubar.find('.meganav').prepend(
			$('<a href="#" class="close">Loka</a>').on('click', function(e) {
				e.preventDefault();
				$('.skiplink a:first').click();
			})
		);

		// mobile stuff
		$meganav.treeCollapse({
			branch: 'li:has(ul)',
			doTogglers: 1,
			toggler: '> a.expand',
			startOpen: '.mnav__li--parent, mnav__li--current',
		});

		$meganav.on('click', 'a.expand', function() {
			const clickedBranch = $(this).parent();
			clickedBranch
				.closest('ul')
				.find('> li')
				.not(clickedBranch)
				.each(function() {
					if ($(this).is('.open')) {
						$(this)
							.removeClass('open')
							.addClass('closed');
					}
				});
		});

		$meganav.on('click', 'a:not(.expand)', function(e) {
			if (
				media.isHeaderSmall &&
				$(this)
					.parent()
					.is('.closed')
			) {
				$(this)
					.prev('.expand')
					.trigger('click');
				e.preventDefault();
			}
		});

		// desktop stuff
		$win
			.on('formatchange.megamenu', function() {
				if (media.becameHeaderLarge) {
					$meganav.find('> li > .sub-menu').each(function() {
						$(this).wrap('<div class="sub-menu-wrap"></div>');
					});
					$meganav.find('.menu-item.open').removeClass('open');
				} else if (media.becameHeaderSmall) {
					$meganav.find('.sub-menu-wrap').zap();
				}
			})
			.trigger('formatchange.megamenu');

		$meganav
			.delayedHighlight({
				delegate: '> li:has(ul)',
				delay: 100,
				delayOut: 150,
				// sticky:       true,
				// click:        true,
				// clickToggles: false,
				// clickCancels: false
			})
			.on('highlighton', function(e) {
				if (media.isHeaderLarge) {
					const itm = $(e.target);
					setTimeout(function() {
						itm.addClass('focus-show');
					}, 110);
				}
			})
			.on('highlightoff', function(e) {
				const itm = $(e.target);
				itm.removeClass('focus-show');
			});

		// annoying hack to remove current classes from custom links parents
		$meganav.find('.custom.current-menu-item').each(function() {
			$(this)
				.parents('li')
				.removeClass(
					'current-menu-ancestor current-menu-parent current_page_parent current_page_ancestor'
				);
		});

		$doc.on('click', function(e) {
			if (!$(e.target).is('.skiplink a') && $html.is('.is-menu-open')) {
				$('.skiplink a:first').trigger('click');
			}
		});

		$win.on('keyup', function(e) {
			if (e.which === 27 && $html.is('.is-menu-open')) {
				$('.skiplink a:first').trigger('click');
			}
		});
	};

	const initSearch = () => {
		const $qsearch = $('.widget_search').attr('aria-hidden', 'true');
		const searchTrigger = $('<button class="search-trigger" type="button">Leit</button>');

		$qsearch.find('.searchform').elasticSearch({
			inputSelector: '.searchform__field',
			apiKey: 'heyrnartaekni-ghozkeibegd',
		});

		$qsearch.on('click', function(e) {
			e.stopPropagation();
		});

		searchTrigger.on('click.trigger', function(e) {
			e.stopPropagation();
			$html.toggleClass('search-active');
			if ($html.is('.search-active')) {
				$qsearch.removeAttr('aria-hidden');
				setTimeout(function() {
					$qsearch.find('input.searchform__field').focusHere();
				}, 50);
			} else {
				$qsearch.attr('aria-hidden', 'true');
			}
		});

		$win.on('formatchange', function(/*e*/) {
			if (media.becameHeaderLarge) {
				$qsearch.attr('aria-hidden', 'true');
				$('.pgnav')
					.append(searchTrigger)
					.append($qsearch);
			} else if (media.becameHeaderSmall) {
				$qsearch.appendTo('.meganav .mnav__boxbody').removeAttr('aria-hidden');
				searchTrigger.detach();
			}
		});

		$doc.on('click', function(/*e*/) {
			if ($html.is('.search-active')) {
				searchTrigger.trigger('click.trigger');
			}
		});

		$win.on('keyup', function(e) {
			if (e.which === 27 && $html.is('.search-active')) {
				searchTrigger.trigger('click.trigger');
			}
		});
	};

	// ctf7 response
	const _reservationResponse = (ctReservationResponse, reservationFormF) => {
		if (ctReservationResponse || !ctReservationResponse === null) {
			ctReservationResponse.style.display = 'none';
			document.addEventListener(
				'wpcf7mailsent',
				function(/*event*/) {
					ctReservationResponse.style.display = 'flex';
					reservationFormF.style.display = 'none';
				},
				false
			);
		}
	};

	const initLandsbyggdinForm = () => {
		const $reservationForm = $('.reservation').hide();
		const reservationFormF = document.querySelector('.reservation__form form');
		const $landsbyggdinForm = $('.landsbyggdin__form');

		const ctReservationResponse = document.querySelector('.reservation__form__thank-you');
		_reservationResponse(ctReservationResponse, reservationFormF);

		$landsbyggdinForm
			.on('change', '#stadsetning-fake', function() {
				const dateStr = $(this)
					.find('option:selected')
					.attr('data-nextdate');
				if (dateStr) {
					$landsbyggdinForm
						.find('.reservation__reserve-title')
						.text('Næsti tími: ' + dateStr);
					$landsbyggdinForm.find('#dagsetning').val(dateStr);
				} else {
					$landsbyggdinForm.find('.reservation__reserve-title').text('Tímapöntun');
					$landsbyggdinForm.find('#dagsetning').val('');
				}
			})
			.trigger('change');

		$reservationForm.on('change', '#stadsetning-fake', function() {
			const dateStr = $(this)
				.find('option:selected')
				.attr('data-nextdate');
			if (dateStr) {
				$reservationForm
					.find('.reservation__reserve-title')
					.text('Næsti tími: ' + dateStr);

				$reservationForm.find('#dagsetning').val(dateStr);
			} else {
				$reservationForm.find('.reservation__reserve-title').text('Tímapöntun');
				$reservationForm.find('#dagsetning').val('');
			}
		});

		$landsbyggdinForm.on('click', 'button', () => {
			const reservationSource = document.querySelector('.landsbyggdin__form');
			const reservationTarget = document.querySelector('.reservation__col--right');
			const reservationSourceSelectVal = reservationSource.querySelector(
				'#stadsetning-fake'
			);

			const reservationSourceOptions = reservationSourceSelectVal.options.selectedIndex;

			const reservationCloned = reservationSource.cloneNode(true);
			reservationTarget.appendChild(reservationCloned);
			document
				.querySelector('.reservation__form input#timapontun1-fake')
				.setAttribute('id', 'timapontun1');
			document
				.querySelector('.reservation__form input#timapontun1 + label')
				.setAttribute('for', 'timapontun1');
			document
				.querySelector('.reservation__form input#timapontun2-fake')
				.setAttribute('id', 'timapontun2');
			document
				.querySelector('.reservation__form input#timapontun2 + label')
				.setAttribute('for', 'timapontun2');

			$reservationForm.fadeIn(200, () => {
				$reservationForm.focusHere();
			});

			const reservationClonedOptions = document.querySelector(
				'.reservation__form #stadsetning-fake'
			);

			reservationClonedOptions.selectedIndex = reservationSourceOptions;

			// remove form
			const closeBtn = $('.reservation__close');
			const clonedForm = document.querySelector('.reservation .landsbyggdin__form');
			closeBtn.each(function() {
				$(this).on('click', () => {
					$reservationForm.hide();
					clonedForm.remove();
					ctReservationResponse.style.display = 'none';
					reservationFormF.style.display = 'block';
				});
			});
		});
	};

	const initCookieConsent = () => {
		$.cookieConsent.lang.en['disclaimer-Intro'] =
			'This website uses cookies to measure traffic.';
		$.cookieConsent.lang.is['disclaimer-Intro'] =
			'Þessi vefur mælir umferð um vefinn með vafrakökum.';
		$.cookieConsent.lang.en['disclaimer-Accept'] = 'Accept';
		$.cookieConsent.lang.is['disclaimer-Accept'] = 'Samþykkja';
		$.cookieConsent.lang.en['disclaimer-Deny'] = 'Deny';
		$.cookieConsent.lang.is['disclaimer-Deny'] = 'Hafna';
		$.cookieConsent.lang.en['myConsent-trackers'] = 'Google Analytics';
		$.cookieConsent.lang.is['myConsent-trackers'] = 'Google Analytics';
		$.cookieConsent.lang.en['disclaimer-PrivacyPolicy-LinkText'] = 'See more';
		$.cookieConsent.lang.is['disclaimer-PrivacyPolicy-LinkText'] =
			'Persónuverndarstefna okkar';
		$.cookieConsent.lang.en['disclaimer-PrivacyPolicy-Link'] = '/personuvernd';
		$.cookieConsent.lang.is['disclaimer-PrivacyPolicy-Link'] = '/personuvernd';

		$.cookieConsent.lang.en['myConsent-button-Accept'] = 'Allow tracking cookies';
		$.cookieConsent.lang.is['myConsent-button-Accept'] = 'Ég leyfi mælingar';
		$.cookieConsent.lang.en['myConsent-button-Deny'] = 'Deny tracking cookies';
		$.cookieConsent.lang.is['myConsent-button-Deny'] = 'Ég leyfi ekki mælingar';

		$.cookieConsent({
			privacyPolicyTempl:
				'<a class="link" href="%{privacyPolicyLink}">%{privacyPolicyLinkText}</a>',
			injectSelector: '.page-personuvernd h1',
		});
	};

	// =========================================================================================================================
	//   Run Init Actions
	// =========================================================================================================================

	$('ol').attr('data-oltype', function() {
		return this.type || '';
	}); // enable fancy styling on <ol> markers....

	tagFileAndExternalLinks(); // Þarf að keyrast soldið seint vegna ga tracking
	$('table:not(table table)').wrap('<div class="tablewrap" />');

	prepArticleContent();
	initForms();

	$.initMobileMenu({
		mediaGroup: null,
		stickyHeader: false,
		resetScroll: false,
	});

	$.initStickyHeader({
		mediaGroup: null,
		headerHeight: function() {
			return parseInt(
				window.getComputedStyle(document.documentElement).getPropertyValue('padding-top')
			);
		},
	});

	initMegaNav();
	initContentblocksAnimations();
	initSearch();

	initContentlist();
	initLandsbyggdinForm();

	handleTelephoneLinks(); // <- depends on formatChange

	$html.removeClass('beforejsinit');
	$html.removeClass('loading');
	$win.on('beforeunload', function() {
		$html.addClass('loading');
	});

	$.fixSkiplinks && $.fixSkiplinks();

	// initCookieConsent();
});
